import { render, staticRenderFns } from "./CalendarEventChip.vue?vue&type=template&id=58a0e716"
import script from "./CalendarEventChip.vue?vue&type=script&lang=js"
export * from "./CalendarEventChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports